import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { MutationKeys } from "constants/mutation-keys";
import { ToastContent, getToastContent } from "constants/toasts";
import { ApiManager } from "services/api";
import { ToastVariant, ToastsActions } from "store/features/toasts";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const connectOpenWidget = async () => {
  const { error, result } = await ApiManager.integrationsApi.connectOpenWidget();
  if (error) {
    throw error;
  }
  return result;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useConnectOpenWidget = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationKey: [MutationKeys.OpenWidget, "connect"],
    mutationFn: connectOpenWidget,
    onSuccess: () => {
      queryClient.invalidateQueries(["openWidgetState"]);
      dispatch(
        ToastsActions.createToast({
          variant: ToastVariant.Success,
          content: getToastContent(ToastContent.OPENWIDGET_CONNECT_SUCCESS),
        })
      );
    },
    onError: () => {
      dispatch(
        ToastsActions.createToast({
          variant: ToastVariant.Error,
          content: getToastContent(ToastContent.OPENWIDGET_CONNECT_FAILURE),
        })
      );
    },
  });
};
